<template>
  <div class="list">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.agentCode" placeholder="代理代号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.agentName" placeholder="代理名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchAgentList" type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button @click="addAgentPop" type="primary" size="small">新增代理</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('common.handle')" width="240">
          <template slot-scope="scope">
            <el-button @click="changeAgentInfo(scope.row)" size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button @click="deleteAgentInfo(scope.row.id)" size="mini" type="primary">{{$t('common.delete')}}
            </el-button>
            <el-button @click="auditAgentInfo(scope.row)" size="mini" type="danger">
              {{scope.row.auditStatus==0?'待审批':scope.row.auditStatus==1?'已审批':'未通过'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentAgentList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="新增代理" :visible.sync="isAddAgentPop">
      <el-form label-width="180px" :model="addAgentForm" :rules="rules" ref="addAgentForm">
        <el-form-item label="代理所属" prop="pid">
          <el-select v-model="addAgentForm.pid" placeholder="请选择所属代理">
            <el-option
              v-for="item in addAgentForm.belongsData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支持平台" prop="tradePlatform">
          <el-checkbox v-model="addAgentForm.tradePlatform">TRADE</el-checkbox>
        </el-form-item>
        <el-form-item label="代理名称" prop="agentName">
          <el-input v-model="addAgentForm.agentName"></el-input>
        </el-form-item>
        <el-form-item label="交易奖励方案" prop="assignPlan">
          <el-select v-model="addAgentForm.assignPlan" placeholder="请选择交易奖励方案">
            <el-option
              v-for="item in addAgentForm.tradePlanData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="层级奖励方案" prop="assignLevelPlan">
          <el-select v-model="addAgentForm.assignLevelPlan" placeholder="请选择层级奖励方案">
            <el-option
              v-for="item in addAgentForm.levelPlanData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitAddAgentForm('addAgentForm')">{{$t('common.ok')}}</el-button>
        <el-button @click="cancelAddAgentForm('addAgentForm')">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="代理信息" :visible.sync="isAgentInfoPop" top="6vh">
      <el-form label-width="180px">
        <el-form-item label="代理层级">
          <el-input v-model="agentInfoForm.agentLevel" readonly></el-input>
        </el-form-item>
        <el-form-item label="上级代理">
          <el-input v-model="agentInfoForm.pid" readonly></el-input>
        </el-form-item>
        <el-form-item label="代理代号">
          <el-input v-model="agentInfoForm.agentCode" readonly></el-input>
        </el-form-item>
        <el-form-item label="代理客户开户编号">
          <el-input v-model="agentInfoForm.agentExtensionCode" readonly></el-input>
        </el-form-item>
        <el-form-item label="代理名称">
          <el-input v-model="agentInfoForm.agentName"></el-input>
        </el-form-item>
        <el-form-item label="交易奖励方案">
          <el-select v-model="agentInfoForm.assignPlan" placeholder="请选择交易奖励方案">
            <el-option
              v-for="item in agentInfoForm.tradePlanData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="层级奖励方案">
          <el-select v-model="agentInfoForm.assignLevelPlan" placeholder="请选择层级奖励方案">
            <el-option
              v-for="item in agentInfoForm.levelPlanData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易平台">
          <el-select v-model="agentInfoForm.tradePlatform" placeholder="请选择交易平台">
            <el-option
              v-for="item in agentInfoForm.platformData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="agentInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="agentInfoForm.card"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="agentInfoForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="代理关联账号">
          <el-input v-model="agentInfoForm.agentAccount"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="agentInfoForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary" @click="submitEditAgentForm()">{{$t('common.ok')}}</el-button>
        <el-button @click="isAgentInfoPop=false">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { localRead } from '@/utils/tools'
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'list',
    data() {
      return {
        userInfo: JSON.parse(localRead('rebate_sys_userInfo')),  //用户信息
        form: {
          agentCode: '',
          agentName: ''
        },
        tableNav: [
          { name: '代理代号', id: 'agentCode' },
          { name: '代理名称', id: 'agentName' },
          { name: '代理客户开户编码', id: 'agentExtensionCode' },
          { name: '支持平台', id: 'tradePlatform' },
          { name: '交易奖励方案', id: 'assignPlans' },
          { name: '层级奖励方案', id: 'assignLevelPlans' },
          { name: '代理来源', id: 'auditTime' },
          { name: '代理级别', id: 'agentLevel' },
          { name: '上级代理', id: 'pid' },
          { name: '子代理数量', id: 'auditor' },
          { name: '创建时间', id: 'createTime' },
          { name: '创建人', id: 'operator' },
          { name: '代理状态', id: 'auditStatuss' },
          { name: '审批时间', id: 'auditTime' },
          { name: '审批人', id: 'auditor' }
        ],
        tableData: [],
        isAddAgentPop: false,
        addAgentForm: {
          pid: '',
          belongsData: [],
          tradePlatform: '',
          agentName: '',
          assignPlan: '',
          tradePlanData: [],
          assignLevelPlan: '',
          levelPlanData: []
        },
        rules: {
          pid: [
            { type: 'date', required: true, message: '请选择所属代理', trigger: 'change' }
          ],
          tradePlatform: [
            { required: true, message: '请选择支持平台', trigger: 'blur' }
          ],
          agentName: [
            { required: true, message: '请输入代理名称', trigger: 'change' }
          ],
          assignPlan: [
            { type: 'date', required: true, message: '请选择交易奖励方案', trigger: 'change' }
          ]
        },
        isAgentInfoPop: false,
        agentInfoForm: {
          agentLevel: '',
          pid: '',
          agentCode: '',
          agentExtensionCode: '',
          agentName: '',
          assignPlan: '',
          tradePlanData: [],
          assignLevelPlan: '',
          levelPlanData: [],
          tradePlatform: '',
          platformData: [],
          name: '',
          card: '',
          phone: '',
          agentAccount: '',
          remark: ''
        },
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getAgentListData(data) {
        nationalMarketing.queryUnionAgentListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].createTime)) {
                  data[i].createTime = new Date(data[i].createTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].auditTime)) {
                  data[i].auditTime = new Date(data[i].auditTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].assignPlan)) {
                  this.addAgentForm.tradePlanData.forEach(row => {
                    if (row.id == data[i].assignPlan) {
                      data[i].assignPlans = row.name
                    }
                  })
                }
                if (Util.isNotEmpty(data[i].assignLevelPlan)) {
                  this.addAgentForm.levelPlanData.forEach(row => {
                    if (row.id == data[i].assignLevelPlan) {
                      data[i].assignLevelPlans = row.name
                    }
                  })
                }
                if (Util.isNotEmpty(data[i].auditStatus)) {
                  if (data[i].auditStatus == 0) data[i].auditStatuss = '待审批'
                  if (data[i].auditStatus == 1) data[i].auditStatuss = '审批通过'
                  if (data[i].auditStatus == 2) data[i].auditStatuss = '审批不通过'
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initAgentListData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getAgentListData(data)
      },
      changeCurrentAgentList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getAgentListData(data)
      },
      searchAgentList() {
        let data = {
          agentCode: this.form.agentCode,
          agentName: this.form.agentName,
          pageNum: 1
        }
        this.getAgentListData(data)
      },
      initAgentSelectTree() {
        nationalMarketing.queryAgentSelectTree().then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = []
              for (const i in res.result) {
                data.push({ name: res.result[i].agentName, id: res.result[i].id, code: res.result[i].agentCode })
              }
              this.addAgentForm.belongsData = data
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initAssignPlanList() {
        let data = { auditStatus: 1 }
        nationalMarketing.queryAssignPlanList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = []
              for (const i in res.result) {
                data.push({ name: res.result[i].planName, id: res.result[i].id })
              }
              this.addAgentForm.tradePlanData = data
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initAssignLevelPlanList() {
        let data = { auditStatus: 1 }
        nationalMarketing.queryAssignLevelPlanList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = []
              for (const i in res.result) {
                data.push({ name: res.result[i].planName, id: res.result[i].id })
              }
              this.addAgentForm.levelPlanData = data
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      addAgentPop() {
        this.isAddAgentPop = !this.isAddAgentPop
      },
      addAgent() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          pid: this.addAgentForm.pid,
          tradePlatform: 'TRADE',
          agentName: this.addAgentForm.agentName,
          assignPlan: this.addAgentForm.assignPlan,
          assignLevelPlan: this.addAgentForm.assignLevelPlan
        }
        nationalMarketing.addAgent(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.isAddAgentPop = false
              this.$message.error('添加成功！')
              this.initAgentListData()
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      submitAddAgentForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addAgent()
          } else {
            return false
          }
        })
      },
      cancelAddAgentForm(formName) {
        this.$refs[formName].resetFields()
        this.isAddAgentPop = !this.isAddAgentPop
      },
      changeAgentInfo(obj) {
        this.isAgentInfoPop = !this.isAgentInfoPop
        this.agentInfoForm = obj
        this.agentInfoForm.tradePlanData = this.addAgentForm.tradePlanData
        this.agentInfoForm.levelPlanData = this.addAgentForm.levelPlanData
        this.agentInfoForm.platformData = [{ name: 'TRADE', id: 'TRADE' }]
      },
      submitEditAgentForm() {
        /*let data = JSON.parse(JSON.stringify(this.agentInfoForm));
        delete data.tradePlanData;
        delete data.levelPlanData;
        delete data.platformData
        console.log(data)*/
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          id: this.agentInfoForm.id,
          agentLevel: this.agentInfoForm.agentLevel,
          pid: this.agentInfoForm.pid,
          agentCode: this.agentInfoForm.agentCode,
          agentExtensionCode: this.agentInfoForm.agentExtensionCode,
          agentName: this.agentInfoForm.agentName,
          assignPlan: this.agentInfoForm.assignPlan,
          assignLevelPlan: this.agentInfoForm.assignLevelPlan,
          tradePlatform: this.agentInfoForm.tradePlatform,
          name: this.agentInfoForm.name,
          card: this.agentInfoForm.card,
          phone: this.agentInfoForm.phone,
          agentAccount: this.agentInfoForm.agentAccount,
          remark: this.agentInfoForm.remark
        }
        nationalMarketing.updateAgent(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.isAgentInfoPop = false
              this.$message.error('修改成功！')
              this.initAgentListData()
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      deleteAgentInfo(ID) {
        let form = new FormData()
        form.append('id', ID)
        nationalMarketing.deleteAgent(form).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.$message.error('删除成功！')
              this.initAgentListData()
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      auditAgentInfo(obj) {
        if (obj.auditStatus == 0) {
          let data = {
            auditStatus: obj.auditStatus,
            auditTime: new Date().getTime(),
            auditor: this.userInfo.id,
            auditorName: this.userInfo.userName
          }
          nationalMarketing.auditAgent(data).then(res => {
            if (res.code == 0) {
              if (res.result) {
                this.$message.error('删除成功！')
                this.initAgentListData()
              }
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    },
    mounted() {
      this.initAgentListData()
      this.initAgentSelectTree()
      this.initAssignPlanList()
      this.initAssignLevelPlanList()
    }
  }
</script>

<style lang="scss" scoped>
  .list {
    margin: 20px;

    .flexCenter {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
